/**
 * @author Supraja Ramesh
 */


import constants, { ACCESS_TOKEN, HTTP_METHODS } from "../../../settings/shared/constants";
import axiosClient from "../../common";

function _constructHeader() {
  const jwtToken = localStorage.getItem(ACCESS_TOKEN);
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${jwtToken}`,
  };
}

/** page is 0-based (Spring Pageable) */
function getAllOrganisations(page = 0, size = 10) {
  return axiosClient({
    url: `${constants.api.organisation.getAll}?page=${page}&size=${size}`,
    method: HTTP_METHODS.GET,
    headers: _constructHeader(),
  });
}

const OrganisationService = {
  getAllOrganisations,
};

export default OrganisationService;